import { StoryblokProductComponentProps } from '../../components/storyblok/storyblok-product-component'

type ProductDetails = StoryblokProductComponentProps['productDetails']

export const getProductDetailsTechSpecs = (
  productDetails: ProductDetails[number]
) =>
  !productDetails.hideTechSpecs && productDetails.techSpecs?.length !== 0
    ? productDetails.techSpecs
    : undefined

export const getProductDetailsSizes = (
  productDetails: ProductDetails[number]
) =>
  !productDetails.hideShapesAndSizes &&
  productDetails.shapesAndSizes?.length !== 0
    ? productDetails.shapesAndSizes
    : undefined

export const getProductDetailsDownloads = (
  productDetails: ProductDetails[number]
) =>
  !productDetails.hideDownloads && productDetails.downloads?.length !== 0
    ? productDetails.downloads
    : undefined

export const getProductDetailsFaq = (productDetails: ProductDetails[number]) =>
  !productDetails.hideFAQs && productDetails.faqs?.length !== 0
    ? productDetails.faqs
    : undefined

export const getProductDetailsVideos = (
  productDetails: ProductDetails[number]
) =>
  !productDetails.hideVideos && productDetails.videos?.length !== 0
    ? productDetails.videos
    : undefined
